import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { dashboardPath } from "./routePaths";

const AccessDeniedComp = () => {

    const navigate = useNavigate()

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
        >
            <Typography>
                It seems you do not have access to this page.
            </Typography>
            <Button
                variant="contained"
                onClick={() => navigate(dashboardPath)}
            >
                Go to dashboard
            </Button>
        </Stack>
    )

}

export default AccessDeniedComp;